import React, { useState } from 'react';

const QuoteModal = ({ isOpen, onClose }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    alert('Quote form submitted');
    onClose(); // Close the modal after submission
  };

  if (!isOpen) return null;

  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Get A Quote</h2>
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-6">
                     <label htmlFor="name">Name:</label>
          <input type="text" id="name" name="name" required />
                </div>
                <div className="col-md-6">
                     <label htmlFor="email">Email:</label>
          <input type="email" id="email" name="email" required />
                </div>
            </div>
         
 <div className="row">
                <div className="col-md-6">
                     <label htmlFor="name">Phone:</label>
          <input type="text" id="name" name="name" required />
                </div>
                <div className="col-md-6">
                     <label htmlFor="email">Company:</label>
          <input type="text" id="company" name="company" required />
                </div>
            </div>
         

          <label htmlFor="details">Details:</label>
          <textarea id="details" name="details" required></textarea>

          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default QuoteModal;
